export interface PasswordStrengthResult {
   contains: string[],
   errors: string[],
   length: number,
   hasSpaces: boolean,
   id: number,
   value: string   
}

export function passwordStrength(password: string | undefined): PasswordStrengthResult {
   const escapeRegExp = (string) => string.replace(/[-.*+?^${}()|[\]\\]/g, '\\$&')
   const defaultOptions = [
      {
         id: 0,
         value: "Too weak",
         minDiversity: 0,
         minLength: 0
      },
      {
         id: 1,
         value: "Weak",
         minDiversity: 1,
         minLength: 8
      },
      {
         id: 2,
         value: "Medium",
         minDiversity: 4,
         minLength: 8
      },
      {
         id: 3,
         value: "Strong",
         minDiversity: 4,
         minLength: 12
      }
   ]

   let passwordCopy = password || ''
   const rules = [
      {
         regex: "[a-z]",
         message: 'lowercase',
         errorMessage: 'At least 1 lowercase letter is required',
      },
      {
         regex: '[A-Z]',
         message: 'uppercase',
         errorMessage: 'At least 1 uppercase letter is required',
      },
      {
         regex: '[0-9]',
         message: 'number',
         errorMessage: 'At least 1 digit is required',
      },
      {
         regex: `[${escapeRegExp("!@#$%^&*?_~-()")}]`,
         message: 'symbol',
         errorMessage: 'At least 1 special character is required',
      }
   ]
   let strength = {
      contains: rules
         .filter(rule => new RegExp(`${rule.regex}`).test(passwordCopy))
         .map(rule => rule.message),
      errors: rules
         .filter(rule => !new RegExp(`${rule.regex}`).test(passwordCopy))
         .map(rule => rule.errorMessage),
      length: passwordCopy.length,
      hasSpaces: /\s/g.test(passwordCopy),
      id: defaultOptions[0].id,
      value: defaultOptions[0].value,
   };

   let fulfilledOptions = defaultOptions
      .filter(option => strength.contains.length >= option.minDiversity)
      .filter(option => strength.length >= option.minLength)
      .sort((o1, o2) => o2.id - o1.id)
      .map(option => ({ id: option.id, value: option.value }))

   strength.id = fulfilledOptions[0]?.id;
   strength.value = fulfilledOptions[0]?.value;

   return strength;
};